import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * Placeholder cute/kawaii para imagen no disponible o que falló al cargar.
 * Mismo estilo que SinConexionKawaii (estrella del logo + carita) con mensaje de imagen.
 */
const ImagenNoDisponibleKawaii = ({
	width = "100%",
	height = "110px",
	fontFamily = "inherit",
	message = "Imagen no disponible",
	submessage = "No se pudo cargar",
	compact = false,
}) => {
	return (
		<Box
			sx={{
				width,
				height,
				position: "relative",
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				background: "linear-gradient(165deg, #F8FAFC 0%, #EEF2FF 40%, #F5F3FF 100%)",
				borderRadius: "12px",
				border: "2px solid rgba(99, 102, 241, 0.15)",
				boxShadow: "inset 0 2px 12px rgba(99, 102, 241, 0.06), 0 2px 8px rgba(0,0,0,0.04)",
				overflow: "hidden",
				minHeight: 80,
			}}
		>
			{/* Solo icono de imagen (marco) centrado */}
			<Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", mb: "8px" }}>
				<svg
					width={compact ? 32 : 40}
					height={compact ? 28 : 36}
					viewBox="0 0 40 36"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					aria-hidden
				>
					<rect
						x="2"
						y="2"
						width="36"
						height="32"
						rx="4"
						fill="#E0E7FF"
						stroke="#A855F7"
						strokeWidth="1.5"
					/>
					<path d="M 8 24 L 20 14 L 32 24 Z" fill="#C7D2FE" stroke="#8B5CF6" strokeWidth="1" strokeLinejoin="round" />
					<circle cx="28" cy="12" r="3" fill="#FACC15" stroke="#EAB308" strokeWidth="1" />
				</svg>
			</Box>
			{!compact && (
				<>
					<Typography
						variant="body2"
						sx={{
							fontFamily: `${fontFamily} !important`,
							fontSize: "0.75rem",
							fontWeight: 600,
							color: "#4F46E5",
						}}
					>
						{message}
					</Typography>
					<Typography
						variant="caption"
						sx={{
							fontFamily: `${fontFamily} !important`,
							fontSize: "0.65rem",
							color: "#64748B",
						}}
					>
						{submessage}
					</Typography>
				</>
			)}
			{compact && (
				<Typography
					variant="caption"
					sx={{
						fontFamily: `${fontFamily} !important`,
						fontSize: "0.65rem",
						color: "#64748B",
						textAlign: "center",
					}}
				>
					{message}
				</Typography>
			)}
		</Box>
	);
};

export default ImagenNoDisponibleKawaii;
